<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

defineProps({
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);
</script>

<template>
  <div
    class="flow-node min-w-[160px] max-w-[200px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-orange-400' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />
    <div class="flex items-center gap-2 px-3 py-2 bg-orange-500 text-white">
      <span class="i-lucide-git-merge size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ t('FLOW_BUILDER.NODES.MERGE.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
